/**
 *
 * IMPORTANT:
 * This file is used both in vue2 and vue3
 * Dont use the vue syntax and the store concept in this file.
 * For any clarifications please contact Leela
 *
 */
export class CheckForQuickStartPopUp {
  static checkForQuickStartCookie(isDesktop) {
    let showModal = false;
    let modalClosedFromCookie = false;
    let cookies = document.cookie;
    if (cookies.indexOf('quickstartclosed=yes') === -1) {
      modalClosedFromCookie = true;
    }
    if (isDesktop !== undefined) {
      if (isDesktop) {
        return window.enableQuickStart && modalClosedFromCookie;
      } else {
        return window.enableQuickStartMobile && modalClosedFromCookie;
      }
    }
    if (window.enableQuickStart || window.enableQuickStartMobile) {
      showModal = modalClosedFromCookie;
    }
    return showModal;
  }

  static checkForLandingPopUp() {
    const value = sessionStorage.getItem('landingpopup');

    if (value) {
      return value.toString() === 'hide';
    } else if (window.landingPopupStartDate && window.landingPopupEndDate) {
      return this.dateTimeChecker();
    } else {
      return false;
    }
  }

  static dateTimeChecker() {
    let startDate = window.landingPopupStartDate;
    let endDate = window.landingPopupEndDate;
    let d = startDate.split('/');
    let e = endDate.split('/');
    let currDate = new Date();
    let dd = String(currDate.getDate()).padStart(2, '0');
    let mm = String(currDate.getMonth() + 1).padStart(2, '0');
    let yyyy = currDate.getFullYear();
    let tid = [mm, dd, yyyy.toString()];
    let start = new Date(d[2].split(' ')[0], d[0], d[1]);
    let end = new Date(e[2].split(' ')[0], e[0], e[1]);
    let now = new Date(tid[2], tid[0], tid[1]);
    return start <= now && end >= now;
  }
}
